import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface CopySuccessDialogProps {
  open: boolean;
  newCourseId: string;
  newCourseName: string;
  organizationId: string;
  onClose: () => void;
  onNavigate: () => void;
}

const CopySuccessDialog: React.FC<CopySuccessDialogProps> = ({
  open,
  newCourseId,
  newCourseName,
  organizationId,
  onClose,
  onNavigate,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Course Copied Successfully</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          The course "{newCourseName}" has been successfully copied to the selected organization.
        </Typography>
        <Typography variant="body2">
          Would you like to navigate to the new course now?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button onClick={onNavigate} variant="contained" color="primary">
          Go to New Course
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CopySuccessDialog; 